import { render, staticRenderFns } from "./VehicleListCard.vue?vue&type=template&id=2fb2d6f8&scoped=true"
import script from "./VehicleListCard.vue?vue&type=script&lang=ts"
export * from "./VehicleListCard.vue?vue&type=script&lang=ts"
import style0 from "./VehicleListCard.vue?vue&type=style&index=0&id=2fb2d6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2d6f8",
  null
  
)

export default component.exports